/**
 * BOXO – swipe-galleri for produktbilder på mobil (collection-sider)
 * Lagt til 10.09.2026.
 *
 * Web component <product-card-swipe> som ligger rundt et scroll-snap-
 * galleri inni produktkortet (snippets/product-grid-item.liquid).
 * Samme mønster som resten av Impulse-temaet (custom elements i theme.js).
 *
 * Ansvar:
 *  - Synkronisere prikk-indikatoren med hvilket bilde som er synlig.
 *  - Skille et rent trykk (tap) fra en horisontal swipe/drag, slik at
 *    brukeren ikke ved et uhell åpner produktsiden mens de swiper.
 *  - Navigere til produktsiden ved et rent trykk på bildet, siden det
 *    usynlige "trykk hvor som helst"-laget er begrenset bort fra
 *    bildeområdet på swipe-kort (se boxo-product-card-swipe.css).
 *
 * Gjør ingenting på desktop – der er komponenten skjult via CSS, og
 * innholdet er kun DOM som aldri vises.
 */
(function () {
  if (typeof window === 'undefined' || !window.customElements) return;
  if (customElements.get('product-card-swipe')) return;

  var DRAG_THRESHOLD = 8; // px – over denne terskelen regnes det som swipe, ikke tap

  class ProductCardSwipe extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.grid-product__swipe-track');
      this.dots = Array.prototype.slice.call(this.querySelectorAll('.grid-product__swipe-dot'));
      this.url = this.getAttribute('data-url');

      if (!this.track) return;

      this._startX = null;
      this._startY = null;
      this._dragged = false;
      this._scrollRaf = null;

      this._onScroll = this._onScroll.bind(this);
      this._onTouchStart = this._onTouchStart.bind(this);
      this._onTouchMove = this._onTouchMove.bind(this);
      this._onClick = this._onClick.bind(this);

      this.track.addEventListener('scroll', this._onScroll, { passive: true });
      this.track.addEventListener('touchstart', this._onTouchStart, { passive: true });
      this.track.addEventListener('touchmove', this._onTouchMove, { passive: true });
      this.track.addEventListener('click', this._onClick, true);
    }

    disconnectedCallback() {
      if (!this.track) return;
      this.track.removeEventListener('scroll', this._onScroll);
      this.track.removeEventListener('touchstart', this._onTouchStart);
      this.track.removeEventListener('touchmove', this._onTouchMove);
      this.track.removeEventListener('click', this._onClick, true);
    }

    _onScroll() {
      if (!this.dots.length) return;
      if (this._scrollRaf) return;
      var self = this;
      this._scrollRaf = window.requestAnimationFrame(function () {
        self._scrollRaf = null;
        var width = self.track.clientWidth || 1;
        var index = Math.round(self.track.scrollLeft / width);
        self.dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      });
    }

    _onTouchStart(evt) {
      var touch = evt.touches && evt.touches[0];
      if (!touch) return;
      this._startX = touch.clientX;
      this._startY = touch.clientY;
      this._dragged = false;
    }

    _onTouchMove(evt) {
      if (this._startX === null) return;
      var touch = evt.touches && evt.touches[0];
      if (!touch) return;
      var dx = Math.abs(touch.clientX - this._startX);
      var dy = Math.abs(touch.clientY - this._startY);
      if (dx > DRAG_THRESHOLD || dy > DRAG_THRESHOLD) {
        this._dragged = true;
      }
    }

    _onClick(evt) {
      // Noen nettlesere sender et syntetisk click-event etter en swipe.
      // Blokker navigasjon da – dette var en swipe, ikke et tap.
      if (this._dragged) {
        evt.preventDefault();
        evt.stopPropagation();
        this._dragged = false;
        return;
      }
      if (this.url) {
        window.location.href = this.url;
      }
    }
  }

  customElements.define('product-card-swipe', ProductCardSwipe);
})();
